import React, { useState } from 'react';
import { Button, TextInput, Label } from 'flowbite-react';

const ConfigureModuleDays = ({ module, onSave, onCancel }) => {
  const totalDays = module.daywise_plan?.length || 1;
  const normalizeDate = (value) => {
    if (!value) return "";
    const dateObj = new Date(value);
    if (Number.isNaN(dateObj.getTime())) return "";
    return dateObj.toISOString().slice(0, 10);
  };

  const baseDates = (module.enabled_dates?.length
    ? module.enabled_dates
    : module.daywise_plan?.assigned_dates) || [];

  const initialDates = Array.from({ length: totalDays }, (_, index) =>
    normalizeDate(baseDates[index])
  );

  const [dayDates, setDayDates] = useState(initialDates);

  const handleDateChange = (index, date) => {
    const newDates = [...dayDates];
    newDates[index] = date;
    setDayDates(newDates);
  };

  const handleSave = () => {
    // Filter out empty dates and ensure they're in ISO format
    const validDates = dayDates
      .filter(date => date) // Remove empty dates
      .map(date => {
        // Make sure we have a valid date string
        const dateObj = new Date(date);
        return dateObj.toISOString();
      });

    // Make sure we have at least one date
    if (validDates.length === 0) {
      validDates.push(new Date().toISOString());
    }

    const configuredModule = {
      ...module,
      _id: String(module._id), // Ensure _id is a string
      enabled_dates: validDates
    };
    onSave(configuredModule);
  };

  return (
    <div className="p-4 sm:p-6 md:p-10 bg-white min-h-screen">
      <div className="max-w-6xl mx-auto bg-white p-8 rounded-lg shadow-md">
        <h2 className="mb-6 text-2xl font-bold text-center text-gray-800">
          <span className="text-primary">{module.name}</span>
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {Array.from({ length: totalDays }, (_, index) => (
            <div key={index} className="p-4 border rounded-lg hover:shadow-lg transition-shadow">
              <Label htmlFor={`day-${index + 1}`} value={`Day ${index + 1}`} className="font-semibold text-gray-700"/>
              <TextInput
                id={`day-${index + 1}`}
                type="date"
                value={dayDates[index]}
                onChange={(e) => handleDateChange(index, e.target.value)}
                required
                className="mt-2"
              />
            </div>
          ))}
        </div>
        
        <div className="flex justify-end gap-4 pt-8 mt-8 border-t">
          <Button color="gray" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={handleSave} className="bg-primary">
            Save Module
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfigureModuleDays;
